// @flow
import type { TemplateComponent } from '../types';

import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import generalIcons from '~/core/constants/icons/general-svg';
import {
    AttributeIcon,
    AttributeIconContainer,
    AttributeIcons,
    Container,
    Control,
    ControlText,
    Description,
    MoreIcon
} from './styles';
import messages from '../intl';

export default (props: TemplateComponent) => (
    <Container>
        <AttributeIcons>
            {props.when.length > 0 && (
                <AttributeIconContainer>
                    <AttributeIcon type={props.when[0].icon} />
                </AttributeIconContainer>
            )}
            {props.while.length > 0 && (
                <AttributeIconContainer>
                    <AttributeIcon type={props.while[0].icon} />
                </AttributeIconContainer>
            )}
            {props.then.length > 0 && (
                <AttributeIconContainer>
                    <AttributeIcon type={props.then.length > 1 ? generalIcons.MORE_VERTICAL : props.then[0].icon} />
                </AttributeIconContainer>
            )}
        </AttributeIcons>
        <Description>{props.name}</Description>
        <Control>
            <ControlText>
                <FormattedMessage {...messages.setUpNow} />
            </ControlText>
            <MoreIcon type={generalIcons.MORE} />
        </Control>
    </Container>
);



// WEBPACK FOOTER //
// ./src/components/widgets/actions/template/component.js